import React from "react";
import "./Pagenotfound.css";

const Pagenotfound = () => {
    return (
        <>
            <div className="Page_container">
                <div className="center_container">
                    <p className="number">404</p>

                    <div className="pagenotfound">
                        <p className="page">Page</p>
                        <p className="notfound">Not Found</p>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Pagenotfound;